interface BlueBubblesIconProps {
  className?: string;
}

// iMessage-style blue chat bubble (cloned from MessageIcon, recolored to the
// Apple Messages app blue gradient).
export const BlueBubblesIcon = ({ className }: BlueBubblesIconProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 66.145836 66.145836"
  >
    <defs>
      <linearGradient id="bb_grad">
        <stop style={{ stopColor: "#0a7cff", stopOpacity: 1 }} offset="0" />
        <stop style={{ stopColor: "#5fa8ff", stopOpacity: 1 }} offset="1" />
      </linearGradient>
      <linearGradient
        xlinkHref="#bb_grad"
        id="bb_grad_applied"
        x1="-25.272568"
        y1="207.52057"
        x2="-25.272568"
        y2="152.9982"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0.98209275,0,0,0.98209275,-1.0651782,3.7961838)"
      />
    </defs>
    <g transform="translate(59.483067,-145.8456)">
      <g>
        <rect
          ry="14.567832"
          rx="14.567832"
          y="145.8456"
          x="-59.483067"
          height="66.145836"
          width="66.145836"
          style={{
            fill: "url(#bb_grad_applied)",
            fillOpacity: 1,
          }}
        />
        <path
          d="m -26.410149,157.29606 a 24.278298,20.222157 0 0 0 -24.278105,20.22202 24.278298,20.222157 0 0 0 11.79463,17.31574 27.365264,20.222157 0 0 1 -4.245218,5.94228 23.85735,20.222157 0 0 0 9.86038,-3.87367 24.278298,20.222157 0 0 0 6.868313,0.83768 24.278298,20.222157 0 0 0 24.2781059,-20.22203 24.278298,20.222157 0 0 0 -24.2781059,-20.22202 z"
          style={{
            fill: "#ffffff",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
  </svg>
);
